export default __webpack_public_path__ + "static-front/media/ExpandIcon.91dd29b7.svg";